// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-initials-avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #1b2459 0%, #1b2459 35%, #bf1b39 100%);\n  color: #fff;\n  font-weight: 600;\n  line-height: 1;\n  letter-spacing: 0.5px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n  vertical-align: middle;\n}", ""]);
// Exports
module.exports = exports;
